import React from "react"
import { useTranslation } from "react-i18next"

export const Step0 = () => {
	const { t } = useTranslation()

	return (
		<div style={{ paddingBottom: "5rem" }}>
			<img
				style={{
					display: "block",
					height: "15rem",
					width: "100%",
					objectFit: "cover",
					margin: "auto",
				}}
				src="https://kopy.b-cdn.net/connect1.webp"
				srcSet="https://kopy.b-cdn.net/connect2.webp 2x"
			/>

			<div
				style={{
					marginTop: "1rem",
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					gap: "0.5rem",
				}}
			>
				<h1
					style={{
						fontSize: "2.5rem",
						fontWeight: "700",
						color: "#222",
						lineHeight: "1",
					}}
				>
					{t("link_store.last_steps")}
				</h1>
				<p
					style={{
						fontSize: "1rem",
						fontWeight: "500",
						color: "#777",
						lineHeight: "1",
					}}
				>
					{t("link_store.finish_setting_up_your_store")}
				</p>
			</div>
		</div>
	)
}
